import { render, staticRenderFns } from "./ChatTextarea.vue?vue&type=template&id=5f70659c&scoped=true&"
import script from "./ChatTextarea.vue?vue&type=script&lang=ts&"
export * from "./ChatTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./ChatTextarea.vue?vue&type=style&index=0&id=5f70659c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f70659c",
  null
  
)

export default component.exports